import { IVehicle } from "interfaces/session/IVehicle";
import { validateVehicle } from "./validate-vehicle";

interface IProps {
    selectedVehicle: IVehicle | null;
    breadcrumbData: any;
    vehicleAnnotations: any;
    vehicleImages: any;
}

function showInteractiveVehicle({
  selectedVehicle, breadcrumbData, vehicleAnnotations, vehicleImages,
}: IProps) {
  if (!validateVehicle(selectedVehicle) || !vehicleAnnotations || !vehicleImages.angle) {
    return false;
  }
  const tier0 = breadcrumbData?.tier0;
  const annotationTier0 = vehicleAnnotations && Object.values(vehicleAnnotations)
    .flatMap((arr) => arr?.[0]?.predictions || [])
    .find((p) => p?.category?.tier0)?.category?.tier0;

  return (Boolean(annotationTier0 === tier0));
}

export default showInteractiveVehicle;
